/**
 * @flow
 */

import React, { Component } from 'react'

import { AlignTwoChildrenInColumnBlock } from './styledComponents'

class AlignTwoChildrenInRow extends Component {
  render() {
    const {
      firstChildComponent,
      secondChildComponent,
      excludeBottomMargin
    } = this.props
    return (
      <AlignTwoChildrenInColumnBlock excludeBottomMargin={excludeBottomMargin}>
        {firstChildComponent}
        {secondChildComponent}
      </AlignTwoChildrenInColumnBlock>
    )
  }
}

export default AlignTwoChildrenInRow



// WEBPACK FOOTER //
// ./src/components/Home/TestimonialSection/TestimonialComponents/AlignTwoChildrenInColumn/index.js